import React, { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { useNavigate } from "react-router-dom";

const supabaseUrl = process.env.REACT_APP_SUPABAE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASEKEY;
const supabase = createClient(supabaseUrl, supabaseKey);

const Login = () => {
  const navigate = useNavigate();

  const [session, setSession] = useState(null);
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const { data: sessionData, error } = await supabase.auth.getSession();
        if (error) {
          throw error;
        }

        setSession(sessionData.session);
      } catch (error) {
        console.error("Error fetching session:", error.message);
      }
    };

    fetchSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (session) {
        localStorage.setItem("login", "true");
        navigate("/search-bar");
      }
    });

    return () => subscription.unsubscribe();
  }, [navigate]);

  if (!session) {
    return <Auth supabaseClient={supabase} appearance={{ theme: ThemeSupa }} />;
  } else {
    localStorage.setItem("login", "true");
    navigate("/search-bar");
    return <div>Logged in!</div>;
  }
};

export default Login;
